import React from 'react'
import AutoForm from '@components/AutoForm'
import {Field} from 'simple-react-form'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import Button from '@components/Button'
import useRef from '@hooks/useRef'
import useState from '@hooks/useState'
import PropTypes from 'prop-types'

export default function RequestCode(props) {
  const {showRedBorder = false} = props
  const form = useRef()
  const lastEmail = useRef()
  const [email, setEmail] = useState()

  const onError = error => {
    console.log('on error', error)
    if (error.email === 'userNotFound') {
      props.setEmail(email)
    }
  }

  const onSuccess = token => {
    props.setToken(token)
    props.setEmail(email)
  }

  const submit = () => {
    // don't allow two submissions with the same email.
    // this guard is needed to prevent the submission from triggering twice
    // when the onBlur event is clicking the continue button.
    if (lastEmail.current !== email) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      form.current.submit()
      lastEmail.current = email
    }
  }

  return (
    <AutoForm
      mutation="requestLoginCode"
      ref={form}
      onSuccess={onSuccess}
      doc={{email}}
      onChange={({email}) => setEmail(email)}
      onValidationError={onError}>
      <div className="label">Email</div>
      <Field
        fieldName="email"
        type={Text}
        fieldType="email"
        placeholder="Email"
        passProps={{
          onBlur: submit,
          style: showRedBorder ? {border: '1px red solid'} : {}
        }}
      />
      <br />
      <Button loading={props.loading} primary onClick={submit}>
        Continuar
      </Button>
    </AutoForm>
  )
}

RequestCode.propTypes = {
  loading: PropTypes.bool,
  setEmail: PropTypes.func,
  setToken: PropTypes.func,
  showRedBorder: PropTypes.bool
}
